export default __webpack_public_path__ + "static/11-3c95c6eb899510654e95c081e0a57adc.jpg";